<div [class.hidden]="GrowerSearchSliderActive">
  <div class="order-transfer-inner">
    <div class="order-trans-top">
      <div class="order-trans-form">
        <h2>Grower Order Transfer:</h2>
        <div class="row" *ngIf="isSubscriptionAccess">
          <div class="col-md-12 confirmationEmailId">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Non-Subscriber Email:</mat-label>
              <input matInput type="email" name="accountEmail"
                     placeholder="(Separate multiple email addresses by a semi-colon)"
                     [(ngModel)]="accountEmail"
                     [pattern]="emailPattern"
                     (keyup)="validateEmail()"
                     email="true">
              <mat-error *ngIf="isNotValid">
                This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="order-box-outer">
        <div class="row">
          <div class="col-md-12  text-center">
            <div class="order-box card text-center">
              <div class="card-body">
                <h5 class="card-title">Order</h5>
                <p class="card-text">{{fromGrower?.growerOrderList[0].orderNumber}}</p>
              </div>
            </div>
            <div class="order-box card text-center">
              <div class="card-body">
                <h5 class="card-title">Order</h5>
                <p class="card-text">{{toGrower == null ? '' : (toGrower?.growerOrderList.length > 0 ? toGrower?.growerOrderList[0].orderNumber :'New Order')}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row order-box-bottom">
          <div class="col-md-6">
            <div class="orderText fromOrder">
              <span>
                from:
              </span>
              <i class="fas fa-caret-up"></i>
            </div>
          </div>
          <div class="col-md-6">
            <div class="orderText toOrder">
              <span>
                to:
              </span>
              <i class="fas fa-caret-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="transferSec">
      <div class="row">
        <div class="col-md-12">
          <div class="tableContainer margBottom">
            <table class="matTables productTable mat-table">
              <thead>
              <th colspan="3" class="borderR" valign="top">
                <div class="leftColTransfer ">
                  <div class="growerInfo fromDetails">
                    <div class="row">
                      <div class="col-md-2">
                        <p class="accountName">
                          Dealer:
                        </p>
                      </div>
                      <div class="col-md-10">
                        <p class="accountName">
                          {{accountInfo?.accountName}},
                        </p>
                        <p class="accountName"> {{accountInfo?.address1}} {{accountInfo?.city}} - {{accountInfo?.state}} {{accountInfo?.zipCode}}</p>
                        <p class="padding-b0 padding-t0">Account# : {{accountInfo?.accountNumber}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2">
                        From:
                      </div>
                      <div class="col-md-10">
                        <h4>
                          {{fromGrower?.businessName}}
                        </h4>
                        <!--<p class="address">
                          {{fromGrower?.address1}}
                        </p>
                        <p class="address">
                          {{fromGrower?.city}} {{fromGrower?.state}} {{fromGrower?.zip}}
                        </p>-->
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th colspan="2">
                <div class="rgtColTransfer padding-r0 padding-l0">
                  <div class="growerInfoToOuter">
                    <div class="growerInfoTo">
                      <div class="row">
                        <!--<div class="col-md-2 padding-l0 padding-r0 borderBot"><span class="toText">Dealer:</span> </div>-->
                        <div class="col-md-12 padding-l0 padding-r0 material-select toGrowerSelectOuter borderBot">
                          <ng-select name="ddlDealerAccount"
                                     [items]="dealerAccountList"
                                     class="custom-select-grower grower-add-drop toGrowerInfo compact-ddl"
                                     [(ngModel)]="dealerAccountId"
                                     [virtualScroll]="true"
                                     bindLabel="accountName"
                                     bindValue="accountNumber"
                                     placeholder="Dealer To: "
                                     [closeOnSelect]="true"
                                     [searchFn]="dealerAccountSearchFn"
                                     (clear)="resetRemainingQty()"
                                     (change)="setGrowerBasedOnDealer($event)">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <a [matTooltip]="item.isValidAccount ? '' : 'Item restricted from dealer transfer'" #tooltip="matTooltip"
                                 [matTooltipPosition]="'below'" (mouseenter)="$event.stopImmediatePropagation()"
                                 (mouseleave)="$event.stopImmediatePropagation()" (click)="tooltip.show()" matTooltipClass='seed-order-tooltip'>
                                <div class="dropdown-template">
                                  <div class="row">

                                    <div class="col-md-8">
                                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                                        {{item.accountName}}
                                      </h4>
                                      <p class="address" [ngOptionHighlight]="search">
                                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                                      </p>
                                      <!--<p class="phoneNo">
                                        {{item.primaryPhoneNumber}}
                                      </p>-->
                                      <p class="grower-nos">
                                        <span class="grower-gln" [ngOptionHighlight]="search">
                                          Account #: {{item.accountNumber}}
                                        </span>
                                      </p>
                                    </div>


                                  </div>
                                </div>
                              </a>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                        <div *ngIf="toDealerInfo" class="col-md-12 padding-l0">
                          <!--<p class="accountName">

                            {{toDealerInfo.accountName}},
                          </p>-->
                          <p class="accountName">
                            {{toDealerInfo.address1}}, {{toDealerInfo.city}} - {{toDealerInfo.state}} {{toDealerInfo.zip}}
                          </p>
                          <p class="padding-b0 padding-t0">Account# : {{toDealerInfo.accountNumber}}</p>
                        </div>

                        <div class=" col-md-8 padding-l0 padding-r0 material-select updateSeller borderBot">
                          <ng-select name="ddlG2GSeller"
                                     [items]="sellerData"
                                     class="custom-select-grower grower-add-drop toGrowerInfo"
                                     [(ngModel)]="toSellerId"
                                     [virtualScroll]="true"
                                     bindLabel="accountName"
                                     bindValue="accountNumber"
                                     placeholder="Updated Seller:"
                                     [loading]="accountLoading"
                                     [closeOnSelect]="true"
                                     (change)="SellerChange($event)"
                                     [searchFn]="sellerSearchFn">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <!--<b [ngOptionHighlight]="search"></b>-->
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <h4 class="name" [ngOptionHighlight]="search">
                                      {{item.accountName}}
                                    </h4>
                                    <!--<p class="address">
                                      {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                                    </p>-->
                                    <!--<p class="phoneNo">
                                      {{item.primaryPhoneNumber}}
                                    </p>-->
                                    <!--<p class="grower-nos">
                                      <span class="grower-gln">
                                        Account #: {{item.accountNumber}}
                                      </span>
                                    </p>-->
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                        <div class="col-md-4 padding-l0 padding-r0 padding-t9 customerPO">
                          <mat-form-field class="wide100">
                            <input matInput
                                   placeholder="Customer PO#:"
                                   [(ngModel)]="customerPO"
                                   [value]="customerPO"
                                   [maxLength]="maxlength">
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="row">
                        <!--<div class="col-md-1 padding-l0 padding-r0 borderBot"><span class="toText">TO:</span> </div>-->
                        <div class="col-md-12 padding-l0 padding-r0 material-select toGrowerSelectOuter borderBot">
                          <ng-select name="ddlG2GToGrower"
                                     [items]="toGrowerList"
                                     class="custom-select-grower grower-add-drop toGrowerInfo"
                                     [(ngModel)]="selectedGrower"
                                     [virtualScroll]="true"
                                     bindLabel="businessName"
                                     bindValue="gmk"
                                     placeholder="Grower To:"
                                     [loading]="accountLoading"
                                     [closeOnSelect]="true"
                                     (change)="selectToGrower($event)"
                                     (clear)="resetRemainingQty()"
                                     [searchFn]="toGrowerSearchFn">
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                              <div class="dropdown-template">
                                <div class="row">
                                  <div class="col-md-8">
                                    <h4 class="name greenColor" [ngOptionHighlight]="search">
                                      {{item.businessName}}
                                    </h4>
                                    <p class="address" [ngOptionHighlight]="search">
                                      {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zip}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                              </div>
                            </ng-template>
                            <ng-template ng-footer-tmp let-search="searchTerm">
                              <div class="custom-drop-footer">
                                <div class="row">
                                  <div class="col-md-8">
                                    <button *ngIf="dealerAccountId" mat-raised-button class="btns" color="primary" (click)="openSearchGrowerSlider()">Advanced Search</button>
                                  </div>
                                  <div class="col-md-4 bold text-right padding-r25">
                                    {{toGrowerList?.length}} Results
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              </thead>
              <thead>
                <tr class="mat-header-row">
                  <th class="mat-header-cell origProductName">Product</th>
                  <th class="mat-header-cell text-center originalUnit">Original</th>
                  <th class="mat-header-cell text-center modifiedUnit borderR">Remaining</th>
                  <!--<th class="mat-header-cell replacedProductName">Product</th>-->
                  <th class="mat-header-cell text-center editUnit">Transfer Units</th>
                  <th class="mat-header-cell text-center deliveryDate">Delivery</th>
                </tr>
              </thead>
              <tbody *ngFor="let g2g of orderFromToList">
                <tr class="mat-row">
                  <td class="order-info mat-cell origProdNameContent" [ngClass]="!g2g.isValidForRibTransfer ? 'pt-0':''">
                    <div class="unavailable-block-Sec" *ngIf="!g2g.isValidForRibTransfer">
                      <div id="main_{{g2g.rowId}}" class="unavailable-block-outer">
                        <div class="unavailable-block" [ngClass]="g2g.seedNonReturnable ? 'adjustTopHeight':''">
                          <i class="icon-ico-Banned_Circle"></i>
                        </div>
                        <div class="unavail-content" id="sub_{{g2g.rowId}}">
                          <h4>Item restricted to transfer to this dealer.</h4>
                        </div>
                      </div>
                    </div>
                    <div class="d-inline-block">
                      <p matTooltip="{{g2g.Brand}} - {{g2g.MarketingBrand}}" [matTooltipPosition]="'above'" [attr.data-testid]="g2g.ItemNumber">{{g2g.Brand}} - {{g2g.MarketingBrand}}</p>
                      <p class="grower-name" matTooltip="{{g2g.ItemDescription}}" [matTooltipPosition]="'above'">{{g2g.ItemDescription}}</p>
                      <p *ngIf="g2g.seedNonReturnable" class="grower-name nonReturnable">*NON-RETURNABLE</p>
                    </div>
                  </td>

                  <td class="text-center mat-cell ">
                    {{commonService.getFormatedNumber(g2g.OriginalFromQty) | number}}
                  </td>
                  <td class="text-center mat-cell borderR">
                    <!--{{g2g.FromModifyQty}}-->
                    <span *ngIf="(+g2g.RemainingQuantityDO - +g2g.ToPrimaryQtyGO) >= 0">
                      {{(+g2g.RemainingQuantityDO - +g2g.ToPrimaryQtyGO)}}
                    </span>
                    <span *ngIf="(+g2g.RemainingQuantityDO - +g2g.ToPrimaryQtyGO) < 0">
                      0
                    </span>
                  </td>
                  <!--<td class="order-info mat-cell">
    <p>{{g2g.Brand}} - {{g2g.MarketingBrand}}</p>
    <p class="grower-name">{{g2g.ItemDescription}}</p>
  </td>-->
                  <td class="text-center mat-cell ">
                    <div *ngIf="g2g.isValidForRibTransfer">
                      <button *ngIf="dealerAccountId && selectedGrower" (click)="geuValueChange('decrease',g2g);g2g.isSelected=true" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + g2g.ItemNumber"> - </button>
                      <input *ngIf="dealerAccountId && selectedGrower" type="text" id="txtUnits" class="geu-txt" [(ngModel)]="g2g.ToPrimaryQtyGO" (focusout)="validateSelectedCount(g2g, $event.target.value)" maxlength="9" appNumbersOnly [attr.data-testid]="'qty-' + g2g.ItemNumber" />
                      <button *ngIf="dealerAccountId && selectedGrower" (click)="geuValueChange('increase',g2g); g2g.isSelected=true" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + g2g.ItemNumber"> + </button>
                    </div>
                  </td>
                  <td class="text-center mat-cell deliveryDatePicker">
                    <mat-form-field [class.invalid-field]="g2g.ToDeliveryDate?false:true">
                      <input matInput [readonly]="true" [matDatepicker]="picker" [(ngModel)]="g2g.ToDeliveryDate" placeholder="Delivery Date" (focus)="picker.open();" [matDatepickerFilter]="dateFilter">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </td>
                </tr>
                <tr *ngIf="g2g && g2g.LineErrors.errors.length > 0" id="error_{{g2g.LineErrors.rowId}}">
                  <td colspan="5">
                    <div class="inline-error">
                      <div class="row">
                        <div class="col-md-12">
                          <ol class="error-list">
                            <li *ngFor="let err of g2g.LineErrors.errors" class="justify-content-center align-self-center">
                              {{err.error }}
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="tableTotalsSec">
      <div class="row">
        <div class="col-md-7">
          <button mat-raised-button class="btns" color="primary" [disabled]="!isTransfer || modifiedUnitCount<=0 || isNotValid==true" (click)="confirmToTransfer()">Transfer Units</button>
          <a style="cursor:pointer" (click)="onCancel()">Cancel </a>
        </div>
        <div class="col-md-5 text-right count">
          Transferred Units:
          <span>
            {{modifiedUnitCount}}/{{originalUnitCount}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<app-grower-search [class.hidden]="!GrowerSearchSliderActive" [GrowerSearchSliderActive]="GrowerSearchSliderActive" [usedAsNestedComp]="true"></app-grower-search>
